
import { useContext, useEffect, useState } from 'react'
import Layout from '../Component/layout/main-layout'
import layoutBgImg from '../Images/layout/others.jpg'
import { Context } from '../Store/context'
import { GetPrivacyPolicy } from '../api/Queries/get'
import Loading from '../Component/loader/loader'
import GlobalLayout from '../Component/layout/global-layout'
import { useTranslation } from 'react-i18next'

const PrivacyPolicy = () => {
    const { t } = useTranslation()
    const { showError } = useContext(Context)

    const [privacy, setPrivacy] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        const getPrivacyPolicy = async () => {
            setIsLoading(true)

            try {
                const data = await GetPrivacyPolicy()

                console.log('Privacy Policy:', data)

                setPrivacy(data)
            } catch (error) {
                console.error('Privacy Policy Error:', error)
                showError(error.message)
            } finally {
                setIsLoading(false)
            }
        }

        getPrivacyPolicy()
    }, [showError])

    const formatDate = (date) => {
        if (!date) return ''

        return new Date(date).toLocaleDateString('tk-TM', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        })
    }

    return (
        <GlobalLayout
            title={`${t('privacy_policy')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords='Privacy Policy, Gizlinlik syýasaty, Политика конфиденциальности'
        >
            <div className='mb-20'>

                <Layout
                    title={t('privacy_policy')}
                    layoutBgImg={layoutBgImg}
                />

                <main className='mt-8 media'>
                    <section className='w-full dark:text-dark-text'>
                        {isLoading ? (
                            <Loading />
                        ) : privacy ? (
                            <div className='mt-6'>
                                <div
                                    className='leading-loose text-justify
                                                   prose max-w-none
                                                   dark:prose-invert'
                                    dangerouslySetInnerHTML={{
                                        __html: privacy.content || ''
                                    }}
                                />
                                <div className="mt-2 text-sm mb-2">
                                    <p className='mb-2'>
                                        <span className="font-semibold">{t("last_updated")}:</span>{" "}
                                        {formatDate(privacy.created_at)}
                                    </p>

                                    <p>
                                        <span className="font-semibold">Version:</span>{" "}
                                        {privacy.version}
                                    </p>
                                </div>
                            </div>
                        ) : (
                            <p className='mt-6 text-center text-gray-500'>
                                Privacy Policy maglumatlary tapylmady.
                            </p>
                        )}

                    </section>
                </main>

            </div>
        </GlobalLayout>
    )
}

export default PrivacyPolicy

